var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_4563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5933 18.4396L20 11.9996L13.5933 5.55965C13.5355 5.48367 13.462 5.421 13.3778 5.3759C13.2936 5.3308 13.2007 5.30431 13.1054 5.29823C13.0101 5.29215 12.9146 5.30662 12.8253 5.34065C12.7361 5.37469 12.6552 5.4275 12.5882 5.49552C12.5211 5.56353 12.4695 5.64515 12.4367 5.73486C12.404 5.82457 12.3909 5.92028 12.3983 6.01549C12.4057 6.1107 12.4336 6.20321 12.4799 6.28674C12.5262 6.37027 12.5899 6.44288 12.6667 6.49965L17.46 11.333H4.70667C4.52985 11.333 4.36029 11.4032 4.23526 11.5282C4.11024 11.6533 4.04 11.8228 4.04 11.9996C4.04 12.1765 4.11024 12.346 4.23526 12.4711C4.36029 12.5961 4.52985 12.6663 4.70667 12.6663H17.46L12.6667 17.4996C12.542 17.6252 12.4723 17.7951 12.473 17.972C12.4736 18.1489 12.5445 18.3183 12.67 18.443C12.7955 18.5676 12.9654 18.6373 13.1424 18.6367C13.3193 18.6361 13.4887 18.5652 13.6133 18.4396H13.5933Z",
    fill: "#8E929A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_4563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 1 -1 0 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetailsIcon);
export default __webpack_public_path__ + "static/media/ViewDetailsIcon.558e0606a3edb5a3656bf2b1be6eeea3.svg";
export { ForwardRef as ReactComponent };